export default $ => {

    const moment = require('moment');
    
    $('[data-timer]').each(function () {

        const timer = $(this);
        const expireAt = moment().add(timer.data('timer'), 'seconds');
        const onTick = timer.data('timer-ontick');
        const params = {
            timer: timer,
            diff: null,
            format: '',
            createdAt: new Date(),
            expiresAt: expireAt,
        };

        let interval = setInterval(function () {
            
            const diff = getDiff(expireAt);
            
            if (diff._over) {
                clearInterval(interval);
            }
            
            const min = padNumber(diff.minutes);
            const sec = padNumber(diff.seconds);
            params.diff = diff;
            params.format = min + ':' + sec;
            
            timer.html(params.format);
            
            if (onTick && typeof window[onTick] === 'function') {
                window[onTick](params);
            }
        }, 1000);
    });
    
    const getDiff = dateTime => {
        // Milliseconds diff
        const diffMs = dateTime - moment();
        const diffSec = Math.round(diffMs / 1000);
        const diff = {
            _over: diffMs < 0 || diffSec === 0,
            minutes: Math.floor(diffSec / 60),
            seconds: diffSec % 60,
        };
        
        if (diff.seconds === 60) {
            diff.seconds = 0;
        }
        
        if (diff._over) {
            diff.seconds = 0;
            diff.minutes = 0;
        }
        
        return diff;
    };
    
    const padNumber = (number) => {
        return number < 10 ? '0' + number : number;
    }

};


// WEBPACK FOOTER //
// ./assets/js/component/timer.js